import _isArray from 'lodash/isArray'

const normalizeQuery = (
  query: string | string[] | undefined
): string | null => {
  if (_isArray(query)) return query[0] || null
  return query || null
}

export default normalizeQuery
